import { createAsyncThunk, createSlice, type PayloadAction } from '@reduxjs/toolkit';
import { ntxAPI } from '../../../API/axiosNeatex';
import type { BrandModels } from './BrandModels';

export const addBrand = createAsyncThunk(
  'Brand/addBrand',
  async (item: any, { rejectWithValue, dispatch }) => {
    try {
      const { data } = await ntxAPI.post('Inv/AddBrand', item);
      await dispatch(getBrandList());
      return data;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const updateBrand = createAsyncThunk(
  'Brand/updateBrand',
  async (item: any, { rejectWithValue, dispatch }) => {
    try {
      const { data } = await ntxAPI.post('Inv/UpdateBrand', item);
      await dispatch(getBrandList());

      return data;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const getBrandList = createAsyncThunk(
  'Brand/getBrandList',
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await ntxAPI.get('Inv/GetBrandList');
      if (data.succeeded) {
        return data.data;
      } else {
        return rejectWithValue(data?.message || 'هناك خطأ');
      }
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const getBrandById = createAsyncThunk(
  'Brand/getBrandById',
  async (id: string, { rejectWithValue }) => {
    try {
      const { data } = await ntxAPI.get('Inv/GetBrandById', { params: { id: id } });
      if (data.succeeded) {
        return data.data;
      } else {
        return rejectWithValue(data?.message || 'هناك خطأ');
      }
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

const initialState: {
  BrandList: BrandModels[];
  BrandById: BrandModels;
  loading: boolean;
  loadingById: boolean;
  error: any | null;
} = {
  BrandList: [],
  BrandById: {} as BrandModels,
  loading: false,
  loadingById: false,
  error: null,
};

const BrandSlice = createSlice({
  name: 'Brand',
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder

      .addCase(getBrandList.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(getBrandList.fulfilled, (state, action: PayloadAction<BrandModels[]>) => {
        state.loading = false;
        state.BrandList = action.payload;
      })
      .addCase(getBrandList.rejected, (state, action: PayloadAction<any>) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(getBrandById.pending, (state, action) => {
        state.loadingById = true;
      })
      .addCase(getBrandById.fulfilled, (state, action: PayloadAction<BrandModels>) => {
        state.loadingById = false;
        state.BrandById = action.payload;
      })
      .addCase(getBrandById.rejected, (state, action: PayloadAction<any>) => {
        state.loadingById = false;
        state.error = action.payload;
      });
  },
});

export default BrandSlice.reducer;
